module.exports = __webpack_public_path__ + "media/images/product/c_b-1689146531f171a51052d5710dba6b67.jpg";